<header>
  <app-navbar></app-navbar>
</header>
<mat-drawer-container class="container" autosize>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</mat-drawer-container>
